<div class="col no-overflow padding all full-width">
  <div class="row no-overflow">
    <mat-card class="no-overflow fill padding all full-height">
      <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
      </mat-card-header>
      <table class="mat-elevation-z0 table" mat-table matSort [dataSource]="reports">
        <ng-container matColumnDef="runNewReport">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button
              class="button align-center justify-center autoWidth"
              mat-menu-item
              (click)="generateReport(element, false)"
              [disabled]="disableRunNewReport(element)"
            >
              <mat-icon
                [size]="24"
                matTooltip="Start generating this report."
              >cloud_download
              </mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let element">
            {{ element.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
          <td mat-cell *matCellDef="let element">
            {{ element.description }}
          </td>
        </ng-container>

        <ng-container matColumnDef="reportTypeDescription">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Report Type</th>
          <td mat-cell *matCellDef="let element">
            {{ element.reportTypeDescription ?? '[N/A]' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.createdOn ?? '[N/A]' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            <!-- <button mat-raised-button color="primary" *ngIf="element.status === 3" (click)="downloadReport(element)">
              Download
            </button> -->
            <span style="padding-left: 12px" *ngIf="element.status === null || element.status === undefined"
              >[N/A]</span
            >
            <button
              mat-menu-item
              class="button align-center justify-center autoWidth"
              *ngIf="element.status === 1 || element.status === 2"
              [disabled]
            >
              <mat-spinner [diameter]="25" matTooltip="This report is currently generating."></mat-spinner>
            </button>
            <button
              mat-menu-item
              class="button align-center justify-center autoWidth"
              *ngIf="element.status === 3"
              (click)="downloadReport(element)"
            >
              <mat-icon class="material-icons-outlined green" matTooltip="This report can now be downloaded."
                >download</mat-icon
              >
            </button>
            <button mat-menu-item class="button align-center justify-center autoWidth" *ngIf="element.status === 4">
              <mat-icon
                class="material-icons-outlined red"
                matTooltip="An error has occured with this report. Click here to regenerate. If a problem continues, please contact support."
                (click)="generateReport(element, true)"
                >sync_problem</mat-icon
              >
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>
      </table>
    </mat-card>
  </div>
</div>
